import * as Yup from "yup";

import { AuthKeys, validationMsgs } from "@sso/constant";

export const signInValidation = Yup.object({
  [AuthKeys.EMAIL_USER_NAME]: Yup.string().required(validationMsgs.required).max(100, validationMsgs.maxlength(100)),
  [AuthKeys.PASSWORD]: Yup.string().required(validationMsgs.required).max(50, validationMsgs.maxlength(50)),
});
